import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import Avatar from "../../assets/svg/avatar.svg";
import daburLogo from "../../assets/svg/appIcon.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import Markdown from "markdown-to-jsx";
import classNames from "classnames";
import {
  financeAgentChat,
  getChatBySessionIdForProject,
  getDocumentSessionId,
  getInboxChatBySessionId,
  projectAgentChat,
  setPage,
  setProjectChatsessionId,
  setProjectQueryMessage,
  setSelectedProjectChat,
  uploadFiles,
} from "../../lib/redux/actions";
import TextInput from "../ui/TextInput";
import { useDispatch, useSelector } from "react-redux";
import toast from "../../lib/utils/toast";
import SkeletonLoader from "../../lib/common/components/loader/SkeletonLoader";
import MessageLoader from "../../lib/common/components/loader/MessageLoader";
import BotMarkdown from "../../lib/common/components/markdown/BotMarkdown";
import { CustomLink, preprocessText } from "../../lib/utils/helper";
import WelcomeInterface from "../chat/WelcomeInterface";
import FileCard from "../chat/FileCard";
import UploadFileCard from "../ui/UploadFileCard";
import { Copy, Check, Mic, Download, ChevronDown } from "lucide-react";
import CustomTooltip from "../ui/Tooltip";
import { useLocation, useOutletContext, useParams } from "react-router-dom";
import ReadOnlyChat from "../chat/ReadOnlyChat";
import { trackEvent, trackException } from "../../lib/utils/telemetryService";
import { MESSAGES } from "../../config/messages";
import { ProjectTogglesRow } from "./ProjectTogglesRow";



export default function ProjectChatInterface({
  isMobile,
  sidebarOpen,
  setChats,
  chats,
  fetchRecentChats,

 
  viewLoading = false,
  viewTempId = null,
  parentProjectId = null,
}) {
  const location = useLocation();
  const { projectName, projectId,projectType } = useParams();
  const params = new URLSearchParams(location.search);
  const isRead = params.get("isRead");
  const textRef = useRef("");
  const scrollRef = useRef(null);
  const isFetchingRef = useRef(false);

  const dispatch = useDispatch();
  const { selectedProjectChat, page, projectSessionId, projectQueryMessage } = useSelector(
    (state) => state.chat
  );

  const textDelayTimeout = useRef(null);
  const [displayedText, setDisplayedText] = useState("");
  const [isContentRendering, setIsContentRendering] = useState(false);
  const [tempId, setTempId] = useState(null);
  const inputRef = useRef(null);
  const [inputFocused, setInputFocused] = useState(false);
  const [inputText, setInputText] = useState("");
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasDocument, setHasDocument] = useState(false);

  const [modelName, setModelName] = useState("gpt-4.1-mini");

  const { chatModels, setModelSelectorConfig } = useOutletContext();

  // Build model options map from API response, with fallback to static options
  const MODEL_OPTIONS =
    chatModels && chatModels.length > 0
      ? chatModels.reduce((acc, model) => {
        if (model?.modelKey && model?.modelName) {
          acc[model.modelKey] = model.modelName;
        }
        return acc;
      }, {})
      : {

      };
  const [copiedMessageId, setCopiedMessageId] = useState(null);

  const handleTextDelay = useCallback((msg) => {
    // Clear any existing timeouts
    if (textDelayTimeout.current) {
      clearTimeout(textDelayTimeout.current);
    }

    setIsContentRendering(true);
    let currentIndex = 0;
    const typingSpeed = 2;
    textRef.current = ""; // Use ref instead of state for intermediate values

    const typeNextCharacter = () => {
      if (currentIndex < msg.length) {
        textRef.current = msg.substring(0, currentIndex + 1);
        setDisplayedText(textRef.current);
        currentIndex += 1;
        textDelayTimeout.current = setTimeout(typeNextCharacter, typingSpeed);
      } else {
        setIsContentRendering(false);
      }
    };

    typeNextCharacter();

    // Cleanup function
    return () => {
      if (textDelayTimeout.current) {
        clearTimeout(textDelayTimeout.current);
      }
      setIsContentRendering(false);
    };
  }, []);
  useLayoutEffect(() => {
    // TODO: Remove this after testing
    if (location.pathname === `/project/${projectName}/${projectType}/${projectId}`) {
      dispatch(setSelectedProjectChat({}));
      // setChats([]);
      setHasDocument(false);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const getDoc = async (id) => {
    const res = await getDocumentSessionId(id);

    setHasDocument(res?.data?.document?.length > 0);
  };
  useEffect(() => {
    if (selectedProjectChat?._id) {
      getDoc(selectedProjectChat?._id);
    } else {
      setHasDocument(false);
    }
  }, [selectedProjectChat?._id]);

  useEffect(() => {
    if (
      loading &&
      projectQueryMessage &&
      projectSessionId &&
      projectSessionId === selectedProjectChat?._id
    ) {
      setChats((prev) => [...prev, projectQueryMessage]);
    }
    // eslint-disable-next-line
  }, [selectedProjectChat]);

  useEffect(() => {
    if (
      // TODO: Remove this after testing
      location.pathname !== `/project/${projectName}/${projectType}/${projectId}` &&
      selectedProjectChat?._id &&
      (chats?.length === 0 ||
        (chats[chats.length - 1]?._id &&
          !chats[chats.length - 1]._id.includes("temp-user-")))
    ) {
      // Clear existing chats when selecting a new chat
      setChats([]);
      setHasDocument(false);
      handleGetAllChatBySession(selectedProjectChat?._id, 1);
    }
    // eslint-disable-next-line
  }, [selectedProjectChat]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.scrollLeft = inputRef.current.scrollWidth;
    }
  }, [inputText]);

  useEffect(() => {
    if (chats.length > 0) {
      const lastChat = chats[chats.length - 1];
      if (lastChat.role === "assistant" && lastChat.latest_message) {
        handleTextDelay(lastChat.message);
      } else {
        // Immediately show full message if not latest assistant message
        setDisplayedText(lastChat.message);
      }
    }
  }, [chats, handleTextDelay]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && textDelayTimeout.current) {
        clearTimeout(textDelayTimeout.current);
        setIsContentRendering(false);
      } else if (!document.hidden && chats.length > 0) {
        // When returning to the tab, immediately show the full text
        const lastChat = chats[chats.length - 1];
        if (lastChat.role === "assistant" && lastChat.latest_message) {
          setDisplayedText(lastChat.message);
          setIsContentRendering(false);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (textDelayTimeout.current) {
        clearTimeout(textDelayTimeout.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [chats]);

  //  Get all chat by session ID
  const handleGetAllChatBySession = async (id, pageNumber = 1) => {
    trackEvent("FetchChatsBySessionID", { sessionId: id, pageNumber });
    try {
      const data = {
        page: pageNumber,
        limit: 10,
        sessionId: id,
      };
      const res = await getInboxChatBySessionId(data);
      // const res = dummyResponse;
      const newChats = res.data.data || [];

      const existingIds = new Set(chats.map((chat) => chat._id));
      const uniqueNewChats = newChats.filter(
        (chat) => !existingIds.has(chat._id)
      );

      // Filter chats to ensure they belong to the current session and have a questionId
      const filteredChats = uniqueNewChats
        .filter((chat) => chat.questionId && chat.sessionId?._id === id)
        .reverse();

   const processedMessages = filteredChats.flatMap((chat) => {
  let parsedContent = {};

  try {
    parsedContent =
      typeof chat.content === "string" &&
      chat.content.trim().startsWith("{")
        ? JSON.parse(chat.content)
        : {};
  } catch (error) {
    console.log("JSON parse failed:", error);
    parsedContent = {};
  }

  return [
    {
      role: "user",
      message: chat.questionId.message,
      _id: chat.questionId._id,
      ...(chat?.questionId?.media.length > 0 && {
        media: chat?.questionId?.media,
      }),
      sessionId: chat?.sessionId?._id,
      doc: chat?.sessionId?.document?.[0]?._id || null,
      isAudio: chat?.isAudio,
    },
    {
      role: chat.role,
      message:
        parsedContent?.response || chat.message, // fallback if not JSON
      charts: parsedContent?.charts || chat?.charts || [],
      insights: parsedContent?.insights || chat?.insights || [],
      _id: chat._id,
      sessionId: chat?.sessionId?._id,
      doc: chat?.sessionId?.document?.[0]?._id || null,
      isAudio: chat?.isAudio,
      isDownloadable: chat?.isDownloadble || false,
      fileDownloadLink: chat?.outputUrl,
    },
  ];
});


      setChats((prev) => [...processedMessages, ...prev]); // prepend for inverse
      setHasMore(chats.length + processedMessages.length < res.data.total);
    } catch (error) {
      trackException(error);
      trackEvent("FetchChatsBySessionID_Failed", { sessionId: id });
      console.error(error);
    }
  };

  const handleChatResponse = async ({ text, value, media = [] } = {}) => {
    let tempSessionId = selectedProjectChat?._id || isSelectedSessionId?.current?._id;
    setTempId(selectedProjectChat?._id || isSelectedSessionId?.current?._id);

    const tempUserMessage = {
      role: "user",
      message: text || inputText,
      model_name: modelName,
      sessionId: tempSessionId || `temp-user-${Date.now()}`,
      ...(media.length > 0 && { media: media.map((file) => file.fileUrl) }),
      doc: media.length > 0 ? `temp-user-${Date.now()}` : null,
    };
    dispatch(setProjectQueryMessage(tempUserMessage));
    dispatch(setProjectChatsessionId(selectedProjectChat?._id));

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }, 100); // small delay ensures DOM update
    try {
      setLoading(true);

      const textInput = text || inputText;

      if (!textInput.trim()) {
        return;
      }

      // Clear input
      setInputText("");

      // Add user message optimistically
      const userMessage = {
        role: "user",
        message: textInput,
        model_name: modelName,
        _id: `temp-user-${Date.now()}`,
        ...(media.length > 0 && { media: media.map((file) => file.fileUrl) }),
        doc: media.length > 0 ? `temp-user-${Date.now()}` : null,
        sessionId: tempSessionId || `temp-user-${Date.now()}`,
      };

      setChats((prev) => [...prev, userMessage]);

     const payload = {
        question: textInput,
        projectId:projectId || parentProjectId,
        ...((selectedProjectChat?._id || isSelectedSessionId?.current?._id) && {
          sessionId: selectedProjectChat._id || isSelectedSessionId?.current?._id,
        }),
        ...(media.length > 0 && { media }),
      };

      const payload2 = {
        message: textInput,
        projectId:projectId || parentProjectId,
        ...((selectedProjectChat?._id || isSelectedSessionId?.current?._id) && {
          sessionId: selectedProjectChat._id || isSelectedSessionId?.current?._id,
        }),
        ...(media.length > 0 && { media }),
      };
      let res;
      if(projectType === "finance"){
      res = await financeAgentChat(payload2);
       await handleBotResponse(res);
      }else if(projectType === "generic"){
      res = await projectAgentChat(payload);
      await handleBotResponse(res);
      }
    } catch (error) {
      handleError(error);
      trackException(error);
      trackEvent("SendMessage_Failed");
    } finally {

      setLoading(false);
    }
  };

  const handleBotResponse = async (res) => {
    const { data } = res;

    
    if (!data) return;

     const botMessage = {
      role: "assistant",
      message: data?.answer || data?.response,
      _id: Date.now(),
      doc: data?.userChat?.media[0]?._id || null,
      latest_message: true,
      sessionId: data?.sessionId,
      insights:data?.insights,
      charts:data?.charts,
    };
     const resData = await getChatBySessionIdForProject(data?.sessionId);

    if (!selectedProjectChat?._id) {
      selectedProjectChat?._id && setChats([]);
      dispatch(setProjectChatsessionId(""));

      fetchRecentChats();
       const newSessionId = resData?.data?._id;
      if (newSessionId) {
        // TODO: Remove this after testing
        const newPath  =`/project/${projectName}/${projectType}/${projectId}/${newSessionId}`
        window.history.pushState({}, "", newPath);
      }
      dispatch(setSelectedProjectChat(resData?.data));
    }
    setChats((prev) => [...prev, botMessage]);

 
  };

  const handleError = (error) => {
    const errorBotMessage = {
      role: "assistant",
      message: error?.message || "Something went wrong!!",
      _id: `error-bot-${Date.now()}`,
      statusCode: "error",
    };
    trackException(error); trackEvent("SendMessage_Error", { message: error?.message });
    setChats((prev) => [...prev, errorBotMessage]);
  };

  const fetchMoreData = async () => {
    trackEvent("FetchMoreChats_Attempt", { currentPage: page });
    if (isFetchingRef.current || !hasMore) return;

    isFetchingRef.current = true;

    const nextPage = page + 1;
    await handleGetAllChatBySession(selectedProjectChat?._id, nextPage);
    dispatch(setPage(nextPage));

    isFetchingRef.current = false;
  };

  const handleFileChange = async (e) => {
    const selectedFiles = e.target.files;
    if (!selectedFiles || selectedFiles.length === 0) return;

    const allowedTypes = [
      "text/csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "image/jpeg",
      "image/png",
    ];
    if (files.length + selectedFiles.length > 3) {
      toast.error("You can only upload up to 3 files in total.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return null;
    }

    const MAX_FILE_SIZE_MB = 10;
    const validFiles = Array.from(selectedFiles).filter((file) => {
      const isValidType = allowedTypes.includes(file.type);
      const isValidSize = file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

      if (!isValidType) {
        toast.error(`Unsupported format: ${file.name}`);
        return false;
      }

      if (!isValidSize) {
        toast.error(`File size is too big (Maximum allowed size is 10MB)`);
        return false;
      }

      return true;
    });

    if (validFiles.length === 0) return;

    try {
      setIsUploading(true);
      const formData = new FormData();
      validFiles.forEach((file) => {
        formData.append("files", file);
      });
      trackEvent("FileUpload_Start", { fileCount: validFiles.length });
      const result = await uploadFiles(formData);

      if (result.statusCode === 200) {
        trackEvent("FileUpload_Success", { uploaded: result.data.length })
        const newFileObjs = result.data.map((url, index) => ({
          fileUrl: url,
          fileName: validFiles[index].name,
        }));
        setFiles((prev) => {
          const combined = [...prev, ...newFileObjs].slice(0, 3);
          return combined;
        });
        // Reset file input so re-selecting the same file triggers onChange
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (error) {
      trackException(error);
      trackEvent("FileUpload_Failed");
      console.error("File upload failed:", error);
      toast.error("File upload failed. Please try again.");
    } finally {
      setIsUploading(false);
    }
  };

  const removeFile = (index) => {
    setFiles((prev) => {
      const next = prev.filter((_, i) => i !== index);
      // Also clear the input to allow selecting the same file again
      if (fileInputRef.current) fileInputRef.current.value = "";
      return next;
    });
  };

  const handleCopyText = (text, messageId) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedMessageId(messageId);
        setTimeout(() => {
          setCopiedMessageId(null);
        }, 1000);
      })
      .catch(() => {
        toast.error("Failed to copy text");
      });
  };

  // Ensure selected model exists in the available image models
  useEffect(() => {
    if (chatModels && chatModels.length > 0) {
      const hasCurrent = chatModels.some(
        (m) => m?.modelKey === modelName
      );
      if (!hasCurrent) {
        setModelName(chatModels[0].modelKey);
      }
    }
  }, [chatModels, modelName]);

  // Register model selector in header
  useEffect(() => {
    // Only set config if we have models available
    if (setModelSelectorConfig && chatModels && chatModels.length > 0 && Object.keys(MODEL_OPTIONS).length > 0) {
      setModelSelectorConfig({
        modelName,
        modelOptions: MODEL_OPTIONS,
        modelList: chatModels || [],
        onModelChange: setModelName,
      });
    }
    return () => {
      if (setModelSelectorConfig) {
        setModelSelectorConfig(null);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelName, setModelSelectorConfig, chatModels]);



  const isSelectedSessionId = useRef(selectedProjectChat);


  useEffect(() => {
    isSelectedSessionId.current = selectedProjectChat;
  }, [selectedProjectChat]);


  // Add scroll to bottom function
  const scrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  };

  if (isRead === "true") {
    return <ReadOnlyChat chats={chats} />;
  }

  return (
    <div
      className={`flex-1 flex flex-col overflow-scroll sm:overflow-hidden  ${isMobile && sidebarOpen ? "opacity-50" : ""
        }`}
    >
   

      {!selectedProjectChat?._id && chats?.length === 0 && (
        <WelcomeInterface handleChatResponse={handleChatResponse} />
      )}

      {chats?.length > 0 && (
        <div
          id="scrollableDiv"
          ref={scrollRef}
          className="flex-1 py-4 !px-[30px] sm:px-[50px] md:px-[20px] lg:px-[100px] xl:!px-[220px] 2xl:!px-[220px] overflow-y-auto flex flex-col-reverse mt-[40px]"
        >
          <button
            onClick={scrollToBottom}
            className="fixed bottom-36 right-7 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100 transition-all duration-200 z-20"
          >
            <ChevronDown className="w-5 h-5 text-gray-600" />
          </button>
          <InfiniteScroll
            inverse={true} // Key for chat-style
            dataLength={chats.length}
            next={fetchMoreData}
            hasMore={hasMore}
            // loader={<h4>Loading...</h4>}
            scrollableTarget="scrollableDiv"
            loader={<div className="mx-auto" key={0}></div>}
            endMessage={
              chats?.totalPages >= 2 ? (
                <p className="text-center m-2 font-segoeUI">No More chats!</p>
              ) : (
                ""
              )
            }
            scrollThreshold="200px"
            className="overflow-hidden"
          >
            {chats.map((chat, i) =>
              chat.role === "user" ? (
                <div
                  key={chat._id || `chat-${i}`}
                  className={`flex group justify-end ${i === 0 ? "mt-12 mb-8 " : "mt-8 mb-8"
                    }`}
                >
                  <div className="flex flex-row gap-2">
                    <div className="flex flex-col ">
                      <div className="bg-[#1b5c2926] text-[#000000] flex flex-col gap-2 w-fit overflow-x-auto rounded-bl-[16px] rounded-br-[16px] rounded-tl-[16px] p-[14px] min-h-[44px] justify-center group">
                        <div className="markDownWrapper !leadings-[27px] font-hel leading-[27px] w-fit whitespace-pre-line break-words font-medium text-sm ">
                          <Markdown
                            key={`chat-${chat?._id}`}
                            options={{
                              overrides: {
                                a: { component: CustomLink },
                              },
                            }}
                          >
                            {preprocessText(chat.message)}
                          </Markdown>
                        </div>
                        {chat.media && chat.media.length > 0 && (
                          <div className="mt-2 flex flex-wrap gap-2">
                            {chat.media.map((mediaItem, fileIndex) => (
                              <FileCard
                                index={i}
                                key={`uploadfilecard-${mediaItem.fileUrl}`}
                                mediaItem={mediaItem}
                                fileIndex={fileIndex}
                              />
                            ))}
                          </div>
                        )}
                      </div>
                      <div className="flex items-center justify-between mt-1">
                        <button
                          onClick={() =>
                            handleCopyText(
                              chat.message,
                              chat._id || `chat-${i}`
                            )
                          }
                          className="flex  cursor-pointer items-center gap-1 text-gray-600 p-1 rounded-md hover:bg-[#1b5c2926] opacity-0 group-hover:opacity-100 transition-opacity text-sm  self-start"
                        >
                          <CustomTooltip
                            bgColor={"#000000"}
                            textColor={"#ffffff"}
                            data-tooltip-id={`copy-${chat._id || `chat-${i}`
                              }-tooltip`}
                            data-tooltip-content={
                              copiedMessageId === (chat._id || `chat-${i}`)
                                ? "Copied!"
                                : "Copy"
                            }
                            delay={0}
                            show={true}
                          >
                            {copiedMessageId === (chat._id || `chat-${i}`) ? (
                              <Check color="#000000B2" size={17} />
                            ) : (
                              <Copy color="#000000B2" size={17} />
                            )}
                          </CustomTooltip>
                        </button>
                        {chat?.isAudio && (
                          <div className="p-1 ">
                            <Mic className="text-[#000000B2]" size={16} />
                          </div>
                        )}
                      </div>
                    </div>
                    {!isMobile && (
                      <div className="!w-[35px] flex-shrink-0">
                        <img
                          src={Avatar}
                          alt="Dabur Logo"
                          className="w-[40px]"
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                ((selectedProjectChat?._id && selectedProjectChat?._id === chat.sessionId) ||
                  !selectedProjectChat?._id) && (
                  <div key={chat._id} className="mt-8 mb-8 max-w-4xl space-y-8">
                    <div className="flex gap-4 w-[280px] sm:w-full">
                      {!isMobile && (
                        <div className="w-[40px]">
                          <img
                            src={daburLogo}
                            alt="Dabur Logo"
                            className="w-[40px]"
                          />
                        </div>
                      )}
                      <div className="text-[#000000] flex flex-col gap-2 overflow-x-auto rounded-bl-lg rounded-br-lg rounded-tr-lg min-h-[44px] justify-center w-fit group">
                        <div className="markDownWrapper !leadings-[27px] font-hel w-fit whitespace-pre-line break-words font-medium text-md ">
                          {(() => {
                            let botContent;

                            // Use typing animation only for non-finance projects
                            if (
                              projectType !== "finance" &&
                              chat?.latest_message &&
                              i === chats?.length - 1
                            ) {
                              botContent = preprocessText(
                                chat?.isAudio ? chat?.message : displayedText
                              );
                            } else {
                              // For finance (and all other non-latest messages), render full text immediately
                              botContent = preprocessText(chat?.message);
                            }

                            return <BotMarkdown content={botContent} />;
                          })()}

                          {chat?.insights?.length > 0 && (
                            <div className="mt-4 bg-[#F8FAF9] border border-[#E0E0E0] rounded-lg p-4">
                              <h4 className="font-semibold text-[#1B5C29] mb-2">
                                Key Insights
                              </h4>

                              <ul className="list-disc pl-5 space-y-2 text-sm text-[#333]">
                                {chat.insights.map((insight, idx) => (
                                  <li key={idx}>{insight}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {chat?.charts?.length > 0 && (
                            <div className="mt-6 space-y-4">
                              <h4 className="font-semibold text-[#1B5C29]">
                                Visual Analysis
                              </h4>

                              <div className="grid grid-cols-1  gap-4">
                                {chat.charts.map((chart, idx) => (
                                  <div
                                    key={idx}
                                    className="border rounded-lg p-3 bg-white shadow-sm"
                                  >
                                    <p className="text-sm font-medium mb-2 text-center">
                                      {chart.title}
                                    </p>

                                    <img
                                      src={chart.image_url}
                                      alt={chart.title}
                                      className="w-full rounded-md"
                                      loading="lazy"
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}


                          {chat?.isDownloadable && (
                            <button
                              className={`flex items-center gap-3 py-2 rounded-lg transition `}
                              onClick={() => {
                                if (chat?.fileDownloadLink) {
                                  window.open(chat.fileDownloadLink, "_blank");
                                } else {
                                  toast.error(
                                    "File not available for download"
                                  );
                                }
                              }}
                            >
                              <div className={`bg-white p-3 rounded-full`}>
                                <Download className="w-5 h-5 text-green-800" />
                              </div>
                              <span className="text-base text-[#1B5C29] font-medium">
                                Download File
                              </span>
                            </button>
                          )}

                          <button
                            onClick={() =>
                              handleCopyText(chat.message, chat._id)
                            }
                            className="flex cursor-pointer items-center gap-1 text-gray-600 hover:bg-[#1b5c2926] p-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity text-sm mt-2 self-end"
                          >
                            <CustomTooltip
                              bgColor={"#000000"}
                              textColor={"#ffffff"}
                              data-tooltip-id={`copy-${chat._id}-tooltip`}
                              data-tooltip-content={
                                copiedMessageId === chat._id
                                  ? "Copied!"
                                  : "Copy"
                              }
                              show={true}
                              delay={0}
                            >
                              {copiedMessageId === chat._id ? (
                                <Check color="#000000B2" size={17} />
                              ) : (
                                <Copy color="#000000B2" size={17} />
                              )}
                            </CustomTooltip>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )
            )}
            {loading && selectedProjectChat?._id === tempId && <MessageLoader />}
            {viewLoading && <MessageLoader />}
          </InfiniteScroll>
        </div>
      )}

      {chats?.length === 0 && (selectedProjectChat?._id ? <SkeletonLoader /> : <></>)}

      {/* Text Input and File Uploading */}
      <div
        className={classNames(
          "sticky shadow-[0_-4px_20px_rgba(0,0,0,0.08)] bg-[#ECF2EE] bottom-0 mb-0 py-4 !px-[30px] sm:!px-[150px] md:!px-[20px] lg:!px-[200px] xl:!px-[200px] 2xl:!px-[200px]",
          {
            "opacity-50 pointer-events-none":
              loading && selectedProjectChat?._id === tempId,
          }
        )}
      >
        <div>
          {files.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-2">
              {files.map((file, index) => (
                <UploadFileCard
                  file={file}
                  index={index}
                  key={`uploadfilecard-${file?.fileUrl}}`}
                  removeFile={removeFile}
                />
              ))}
            </div>
          )}
        </div>
        <div
          className="relative w-full !h-[72px] rounded-[14px] !shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]
        "
        >
          <TextInput
            inputRef={inputRef}
            inputText={inputText}
            handleChatResponse={handleChatResponse}
            setInputText={setInputText}
            inputFocused={inputFocused}
            setInputFocused={setInputFocused}
            loading={loading}
            disabled={loading && selectedProjectChat?._id === tempId}
            fileInputRef={fileInputRef}
            handleFileChange={handleFileChange}
            isUploading={isUploading}
            files={files}
            setFiles={setFiles}
            chats={chats}
            isContentRendering={isContentRendering}
            hasDocument={hasDocument}
            //isMultipleFileUploadEnabled={true}
            isFileUploadOptionVisible={false}
            showPromptActions={false}
          />
        </div>
         {/* Toggles row */}
          <ProjectTogglesRow projectType={projectType} />
        <div className="max-w-4xl mx-auto mt-[40px]">
          <p className="text-xs text-gray-500 text-center">
            {MESSAGES.POWERED_BY}
          </p>
        </div>
      </div>
    </div>
  );
}

